var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2043B5",
    d: "M59.58 64.67c.48.34 1.1.43 1.66.22.55-.22.96-.69 1.08-1.26 1.3-6.13 4.47-21.64 5.65-27.2.1-.43-.06-.86-.39-1.15a1.2 1.2 0 00-1.2-.2c-6.28 2.32-25.65 9.6-33.57 12.52-.5.19-.83.67-.8 1.2 0 .53.37.99.88 1.14 3.55 1.07 8.21 2.54 8.21 2.54s2.18 6.58 3.31 9.93c.15.42.47.75.9.86.44.11.9 0 1.22-.3l4.65-4.4s5.36 3.93 8.4 6.1zM43.06 51.65l2.52 8.31.56-5.26 15.28-13.78c.16-.15.18-.4.05-.56a.43.43 0 00-.57-.1l-17.84 11.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.6f8098d6.svg";
export { ForwardRef as ReactComponent };